export default __webpack_public_path__ + "static/media/car6.184b12b8.png";